import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdateEcshopTradesAdditionsRequestModel, UpdateEcshopTradesAdditionsResponseModel } from "@/features/accounts/ecshop/services/update-trades-additions-model";

export class UpdateEcshopTradesAdditionsApi {
  /**
   * その他連携サービス明細メモ・無効明細更新API
   */
  public updateEcshopTradesAdditions = async (
    param: UpdateEcshopTradesAdditionsRequestModel
  ): Promise<UpdateEcshopTradesAdditionsResponseModel> => {
    const path = `/api/ecshopaccounts/ecshops/tradesadditions`;
    const res = await ApiClient.instance.put<UpdateEcshopTradesAdditionsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
